import { AppLayout } from "@/components/AppLayout";
import { PageHeader } from "@/components/ui/page-header";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function FAQ() {
  const faqs = [
    {
      question: "What makes TailorWiz different from other resume builders?",
      answer: "TailorWiz combines intelligent automation with human expertise. Our tools are built to guide you with precision, and our optional services give you direct access to experienced resume professionals who know what hiring managers want."
    },
    {
      question: "Can TailorWiz rewrite my resume using quantifiable accomplishments?",
      answer: "Yes! Our Metrics Wizard is specifically designed to extract performance data from your experience and convert it into bullet points that show measurable value—a must-have for modern resumes."
    },
    {
      question: "Do you write resumes for all industries?",
      answer: "Absolutely. Our team has experience across sales, tech, marketing, healthcare, finance, education, construction, government, and more. Whether you're entry-level or executive, we tailor everything to your field and career goals."
    },
    {
      question: "How long does it take to receive my resume?",
      answer: "Turnaround depends on the service, but typical delivery is within 3–5 business days. Expedited services are available upon request."
    },
    {
      question: "Will my resume be optimized for Applicant Tracking Systems (ATS)?",
      answer: "Yes. All resumes we deliver are formatted and written to pass through ATS software, which most employers use to screen applicants."
    },
    {
      question: "What if I need revisions?",
      answer: "Every service includes at least one round of revisions. We want your final product to feel like you—just elevated and more strategic."
    },
    {
      question: "Is my information kept confidential?",
      answer: "100%. Your resume, contact info, and job goals are all treated with strict confidentiality and used only to deliver your requested service."
    }
  ];

  return (
    <AppLayout>
      <PageHeader 
        title="Frequently Asked Questions" 
        description="Find answers to common questions about TailorWiz"
        backTo="/"
      />
      <div className="container mx-auto max-w-4xl px-4 py-12">
        <div className="text-center mb-12">
          <div className="text-4xl mb-4">🙋</div>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
            Frequently Asked Questions (FAQ)
          </h1>
          <p className="text-lg text-muted-foreground">
            Everything you need to know about TailorWiz and our services
          </p>
        </div>

        <Card className="bg-gradient-to-br from-primary/5 to-accent/5 border-primary/20">
          <CardContent className="p-6">
            <Accordion type="single" collapsible className="w-full">
              {faqs.map((faq, index) => (
                <AccordionItem key={index} value={`item-${index}`} className="border-border/40">
                  <AccordionTrigger className="text-left hover:text-primary transition-colors">
                    <span className="text-base font-semibold pr-4">
                      {index + 1}. {faq.question}
                    </span>
                  </AccordionTrigger>
                  <AccordionContent className="text-muted-foreground leading-relaxed pb-4">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </CardContent>
        </Card>

        {/* Contact Section */}
        <Card className="mt-12 bg-gradient-to-br from-accent/5 to-orange-500/5 border-accent/20">
          <CardHeader className="text-center">
            <CardTitle className="text-2xl font-bold text-foreground">
              Still have questions?
            </CardTitle>
          </CardHeader>
          <CardContent className="text-center pb-8">
            <p className="text-muted-foreground mb-6">
              Can't find the answer you're looking for? We're here to help!
            </p>
            <p className="text-lg">
              Contact us at{" "}
              <a 
                href="mailto:support@tailorwiz.com" 
                className="text-primary underline hover:text-primary/80 font-semibold"
              >
                support@tailorwiz.com
              </a>
            </p>
          </CardContent>
        </Card>
      </div>
    </AppLayout>
  );
}